<template>
  <v-select
    v-model="selectedLanguage"
    :items="languageOptions"
    item-text="text"
    item-value="value"
    height="2rem"
    solo
  >
    <template v-slot:selection="{ item }">
      <div v-if="colLenght < 5">
        <span class="titleLight--text">{{ item.value }}</span>
      </div>
      <div v-if="colLenght > 5">
        <span class="content text-center titleLight--text">{{
          item.text
        }}</span>
      </div>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item @click="update_language(item.value)">
        <v-list-item-content class="content">
          <v-list-item-title class="text-center titleLight--text">{{
            item.text
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "LanguageSelect",
  data() {
    return {
      selectedLanguage: null,
      languageOptions: [
        { text: "English", value: "EN" },
        { text: "Irish", value: "GA" },
        { text: "French", value: "FR" },
        { text: "Spanish", value: "ES" },
        { text: "Polish", value: "PL" },
      ],
    };
  },
  mounted() {
    const language = localStorage.getItem("language");
    this.selectedLanguage = this.languageOptions.find(
      (lang) => lang.value === language
    );
    if (!this.selectedLanguage) {
      this.selectedLanguage = this.languageOptions[0];
    }
  },
  methods: {
    update_language(language) {
      this.$store.commit("set_language", language);
      localStorage.setItem("language", language);
      location.reload();
    },
  },
  props: {
    colLenght: {
      type: Number,
      default: 1,
    },
  },
};
</script>
